import AppPage from '../../mixins/app-page'

export default
{
    name: 'page-404',

    mixins:
    [
        AppPage
    ]
}



// WEBPACK FOOTER //
// ./src/scripts/components/page-404/script.js